import { motion } from 'framer-motion';

const animations = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

function MotionWrapper({ children, ...props }: any) {
    return (
        <motion.div
            variants={animations}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.4 }}
            {...props}
        >
            {children}
        </motion.div>
    );
};

export default MotionWrapper;
